<template>
    <div class="album-detail">
        <div v-if="album.spLinkStatus == 1" class="page-main-title-right">
            <div>歌曲即将上线…</div>
        </div>
        <div v-if="album.spLinkStatus == 2" @click="$router.push(`/manage/album/share/${$route.params.albumId}`)" class="page-main-title-right">
            <el-button type="base">已上线歌曲 →</el-button>
        </div>
        <div class="album-detail-box content-box first" v-loading="dataLoading">
            <TitleTip v-if="album.status === 11 || album.status === 16">审核将在3个工作日内完成</TitleTip>
            <TitleTip v-else-if="album.status === 14 && $route.query.markStatus !== '1'">修改后仍需提交审核</TitleTip>
            <TitleTip v-else-if="album.status === 14 && $route.query.markStatus == '1'">
                <span>该专辑目前需要修改，修改后提交审核;</span>
                <el-tooltip
                    :content="markMessage"
                    placement="top"
                    style="position: absolute; cursor: pointer; color: rgb(24, 141, 247); padding-left: 10px"
                >
                    <span>查看修改指引</span>
                </el-tooltip>
            </TitleTip>
            <TitleTip v-else-if="album.status === 13">
                {{ album.newUnPassAudit ? `失败原因：${album.errorMsg}` : `当前专辑状态为：(修改)审核未通过，原因：${album.errorMsg}` }}
            </TitleTip>
            <TitleTip v-else-if="album.status === 12">专辑通过审核后如需修改信息，请点击“发起修改”按钮，修改后仍然需要提交审核</TitleTip>
            <div class="album-hd">
                <div class="image">
                    <el-image :src="$utils.coverImg(album.cover, 140, 140)" :preview-src-list="[$utils.coverImg(album.cover)]" fit="cover">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <el-button v-if="album.status == 12" type="primary" @click="setModify()">发起修改</el-button>
                    <el-button v-if="album.status == 14 || album.status == 13 || album.status == 10" @click="setModify(1)" type="primary">
                        {{ album.status == 14 || album.status == 13 ? '修改信息' : '编辑专辑' }}
                    </el-button>
                </div>
                <div class="describe">
                    <h2>{{ album.name }}</h2>
                    <el-descriptions :column="3">
                        <el-descriptions-item label="专辑名称">{{ album.name }}</el-descriptions-item>
                        <el-descriptions-item label="表演语言">{{ langCode || '' }}</el-descriptions-item>
                        <el-descriptions-item label="类型">{{ albumType || '' }}</el-descriptions-item>
                        <el-descriptions-item label="流派/风格">{{ genre || '' }}</el-descriptions-item>
                        <el-descriptions-item label="期望上线时间">
                            {{ album.dealStartDate ? $utils.formatDate(album.dealStartDate, 'yyyy年MM月dd日 HH:00') : '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item v-if="album.type == 2" label="是否为AI生成">
                            {{ album?.track?.isAiGenerated == 1 ? '是' : '否' }}
                        </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions :column="3" v-if="hasArtist">
                        <el-descriptions-item span="2" label="艺人信息">
                            <div>
                                <p v-for="(artist, index) in trackArtists" :key="index" style="margin-right: 15px">
                                    {{ artist.value }} -（{{ artist.label }}）
                                </p>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                    <ArtistPlatformProgress
                        v-if="hasArtist"
                        :stats-data="thirdPartyPlatformStats"
                        :artist-progress-data="artistProgressData"
                        :is-editable="false"
                        @handle-click="handleArtistProgressClick"
                    ></ArtistPlatformProgress>
                    <p style="padding: 0 16px 10px 0; font-size: 12px; color: #c0c4cc;" v-if="hasArtist">
                        {{ artistProgressTip }}
                        <span
                            style="cursor: pointer; color: #188df7; margin-left: 10px; border: 1px solid #4d8cff; border-radius: 5px; padding: 5px 10px;"
                            @click="toReleaseArtistDrawer(true)"
                        >
                            查看平台艺人
                        </span>
                    </p>
                    <el-descriptions :column="3">
                        <el-descriptions-item span="2" label="简介">
                            <TextMore :content="album.introduce || '暂无'"></TextMore>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <div class="status">
                    <img v-if="album.status === 10" src="@/assets/img/album/album-status-1.png" />
                    <img v-else-if="album.status === 11" src="@/assets/img/album/album-status-2.png" />
                    <img v-else-if="album.status === 13" src="@/assets/img/album/album-status-3.png" />
                    <img v-else-if="album.status === 12" src="@/assets/img/album/album-status-4.png" />
                    <img v-else-if="album.status === 14" src="@/assets/img/album/album-status-5.png" />
                    <img v-else-if="album.status === 16" src="@/assets/img/album/album-status-6.png" />
                </div>
            </div>
        </div>
        <SongList :list="songList" preview :display-lang-code="album.displayLangCode"></SongList>
        <LrcFormat :lrc="album.lyrics" :src="album.track.path" :visible-preview.sync="dialogVisible" is-preview></LrcFormat>
        <IssueService :visible.sync="issueServicevisible"></IssueService>
        <album-release-dialog
            ref="albumReleaseDialogRef"
            :all-artist-info="allArtistInfo"
            :all-artist-value-options="allArtistValueOptions"
            :is-album="true"
            :display-lang-code="album.displayLangCode"
        ></album-release-dialog>
        <!-- 解决同时修改问题 -->
        <el-dialog
            title="提示"
            :visible.sync="lockDialogVisible"
            width="600px"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :append-to-body="true"
            center
        >
            <div style="line-height: 1.5; margin-bottom: 20px;" v-if="lockAlbumInfo.albumName">
                <span>{{ lockAlbumInfo.firstMsg }}</span>
                <template v-if="lockAlbumInfo.isToAlbum">
                    <el-link href :underline="false" type="primary" @click.prevent="toAlbumInfo(lockAlbumInfo.albumId, lockAlbumInfo.cpId)" style="color:#409EF7!important">
                        《{{ lockAlbumInfo.albumName }}》
                    </el-link>
                </template>
                <template v-else>
                    <span>《{{ lockAlbumInfo.albumName }}》</span>
                </template>
                <span>{{ lockAlbumInfo.endMsg }}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="lockDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {downLoadByUri} from '@/api/file';
import {getLangCode, getGenre, fetchArtistType} from '@/api/common';
import {fetchAlbumSongList, fetchListRelateArtist} from '@/api/album';
import LrcFormat from '@/components/LrcFormat';
import SongList from '../components/SongList';
import AlbumReleaseDialog from '../components/AlbumRelease/AlbumReleaseDialog.vue';
import ArtistPlatformProgress from '../components/ArtistPlatformProgress/index.vue';
import IssueService from '../components/IssueService';

export default {
    components: {
        LrcFormat,
        SongList,
        AlbumReleaseDialog,
        ArtistPlatformProgress,
        IssueService,
    },
    data() {
        return {
            dataLoading: false,
            album: {
                track: {},
            },
            allLangCodeOptions: [],
            allGenreOptions: [],
            artistTypeOptions: [],
            dialogVisible: false,
            songList: [],
            issueServicevisible: false,
            allArtistInfo: [],
            allArtistValueOptions: [],
            artistProgressData: [],
            thirdPartyPlatformStats: [],
            markMessage: this.$route.query.markMessage,
            lockDialogVisible: false,
            lockAlbumInfo: {
                firstMsg: '',
                albumName: '',
                endMsg: '',
                albumId: null,
                cpId: null,
                isToAlbum: false
            }
        };
    },
    created() {
        this.getArtistType();
        this.getAllGenre();
        this.getAllLangCode();
        this.getDataDetail();
        this.getAlbumSongList();
    },
    computed: {
        albumStatus() {
            const {status, spLinkStatus} = this.album;
            if (!status) return 0;
            if (status == 11 || status == 16) return 2; // 11：新增待审核 16:修改待审核
            if (status == 14 || status == 13) return 3; // 14：修改中 13：审核未通过
            if (status == 12) {
                if (spLinkStatus == 2) return 4; // 已上线
                return 3; // 12：审核通过
            }
            return 1;
        },
        albumType() {
            const {type} = this.album;
            if (type === 1) return '专辑';
            if (type === 2) return '单曲';
            if (type === 3) return 'EP';
            return '';
        },
        langCode() {
            const {allLangCodeOptions} = this;
            const {langCode} = this.album;
            if (!langCode) return '';
            const item = allLangCodeOptions.find((row) => row.id == langCode);
            return item && item.name ? item.name : '';
        },
        genre() {
            const {allGenreOptions} = this;
            const {genreId} = this.album;
            if (!genreId || allGenreOptions.length <= 0) return '';
            let allGenre = [];
            allGenreOptions.forEach((row) => {
                const {children, label, value} = row;
                allGenre = [...allGenre, ...children];
                allGenre.push({label, value});
            });
            const item = allGenre.find((row) => row.value == genreId);
            return item && item.label ? item.label : '';
        },
        trackArtists() {
            const {trackArtists} = this.album;
            if (!trackArtists) return [{label: '演唱艺人', value: ''}];
            return trackArtists.map((item) => {
                return {
                    label: item.typeName == '主要艺人' ? '演唱艺人' : item.typeName,
                    value: item.artistName,
                };
            });
        },
        ifLimitAlbumForShowStart() {
            return this.$store.state.userData && this.$store.state.userData.ifLimitAlbumForShowStart;
        },
        hasArtist() {
            return this.trackArtists?.length > 0;
        },
        // 是否可以编辑（未提交、审核未通过、修改中状态下允许编辑）
        isEditable() {
            return this.album.status === 10 || this.album.status === 13 || this.album.status === 14;
        },
        // 艺人进度提示文案
        artistProgressTip() {
            return '建议提前关联各平台艺人主页，可减少作品进入错误主页的情况';
        },
    },
    methods: {
        //前往专辑
        toAlbumInfo(albumId) {
            this.lockDialogVisible = false;
            this.$router.push({
                path: `/manage/album/detail/${albumId}`
            });
        },
        // 发起修改
        async setModify(type) {
            const {status} = this.album;
            if (!type) {
                // 验证VIP是否到期
                const {userState} = this.$store.getters;
                if (userState != 6 && this.ifLimitAlbumForShowStart != 1) {
                    const {userType} = this.$store.state;
                    // 个人还是企业
                    if (userType == 1) {
                        return (this.issueServicevisible = true);
                    } else {
                        return this.$confirm('您的发行服务已经到期，目前企业发行续费服务已经停止，请联系客服进行专辑修改', '温馨提示', {
                            confirmButtonText: '知道了',
                            showCancelButton: false,
                            center: true,
                            type: 'warning',
                        });
                    }
                }
                const flag = await this.$confirm(
                    this.albumStatus == 4 ? '可能会让你修改后的信息，无法及时同步到各个平台' : '发起修改后，可能会影响正常上线时间',
                    '修改专辑',
                    {
                        center: true,
                        confirmButtonText: '确认修改',
                    }
                );
                if (flag === 'cancel') return;
            }
            if (status == 12) {
                const res = await this.$request({
                    url: '/album/up/launch',
                    method: 'POST',
                    data: {albumId: this.$route.params.albumId},
                });
                const {state, msg} = res.data;
                if (!state) return this.$message.error(msg || '请求失败');
            }
            //如果是单曲，检查是否被锁
            if (this.album.type == 2) {
                this.$request({
                    url: 'track/ifLock',
                    method: 'GET',
                    params: {trackId: this.album?.track?.id, albumId: this.$route.params.albumId || this.album?.id},
                })
                    .then((res) => {
                        //处理成功回调
                        if (!Object.keys(res.data.result).length) {
                            this.$router.push({
                                path: `/manage/album/singleTrackInfo/info/${this.album.id}`,
                                query: {
                                    redirect: this.$route.query.redirect || '',
                                    count: this.$route.query.count || 0,
                                    hasAuditPassRecord: this.album.hasAuditPassRecord,
                                },
                            });
                        } else {
                            const {albumName, albumId, lockReason} = res.data.result;
                            /**
                             * lockReason：锁原因
                             * 0:未知原因
                             * 1:修改中
                             * 2:审核中
                             * 3:审核失败
                             */
                            switch (lockReason) {
                                case 0:
                                    this.lockAlbumInfo = {
                                        firstMsg: '该歌曲所在专辑',
                                        albumName,
                                        endMsg: '被锁定，请联系管理员强制释放',
                                        albumId,
                                        cpId: this.album.cpId,
                                        isToAlbum: false,
                                    };
                                    break;
                                case 1:
                                    this.lockAlbumInfo = {
                                        firstMsg: '该歌曲正在专辑',
                                        albumName,
                                        endMsg: '修改中，请前往该专辑继续修改',
                                        albumId,
                                        cpId: this.album.cpId,
                                        isToAlbum: true,
                                    };
                                    break;
                                case 2:
                                    this.lockAlbumInfo = {
                                        firstMsg: '该歌曲所在专辑',
                                        albumName,
                                        endMsg: '已提交审核，请等待审核结束后再修改',
                                        albumId,
                                        cpId: this.album.cpId,
                                        isToAlbum: false,
                                    };
                                    break;
                                case 3:
                                    this.lockAlbumInfo = {
                                        firstMsg: '该歌曲所在专辑',
                                        albumName,
                                        endMsg: '审核驳回后仍保留草稿修改，请前往该专辑处理',
                                        albumId,
                                        cpId: this.album.cpId,
                                        isToAlbum: true,
                                    };
                                    break;
                            }
                            this.lockDialogVisible = true;
                            return false;
                        }
                    })
                    .catch(() => {
                        this.$message.error('获取歌曲信息失败,请重试');
                    })
                    .finally(() => {});
            } else {
                //多曲
                this.$router.push({
                    path: `/manage/album/info/${this.album.id}`,
                    query: {
                        redirect: this.$route.query.redirect || '',
                        count: this.$route.query.count || 0,
                        hasAuditPassRecord: this.album.hasAuditPassRecord,
                    },
                });
            }
        },
        getArtistType() {
            fetchArtistType().then((res) => {
                const {state, result} = res.data;
                if (state && result) {
                    this.artistTypeOptions = (result || [])
                        .map((item) => {
                            const {name, value} = item;
                            return {label: name, value};
                        })
                        .filter((item) => ![1, 2].includes(item.value));
                    this.artistTypeOptions.push({label: '演唱艺人', value: 1});
                }
            });
        },
        //获取表演语言
        getAllLangCode() {
            getLangCode().then((res) => {
                this.allLangCodeOptions = res;
            });
        },
        //获取风格
        getAllGenre() {
            getGenre().then((res) => {
                this.allGenreOptions = res;
            });
        },
        // 获取歌曲列表
        async getAlbumSongList() {
            try {
                const response = await fetchAlbumSongList(this.$route.params.albumId);
                const {state, msg, result} = response.data;
                if (!state) throw new Error(msg || '请求失败');
                this.songList = (result.cdList && result.cdList[0] && result.cdList[0].trackList) || [];
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async getDataDetail() {
            this.dataLoading = true;

            try {
                const params = {albumId: this.$route.params.albumId};
                const response = await this.$request({
                    url: '/album/view/album_info',
                    params,
                    method: 'post',
                });

                const {state, msg, result} = response.data;

                if (!state) {
                    throw new Error(msg || '请求失败');
                }

                const {albumVo = {}, trackDtailVo = {}, alertInfo = '', tracks = [], hasAuditPassRecord, newUnPassAudit, thirdPartyPlatformStats} = result;

                this.album = {
                    ...albumVo.album,
                    lyrics: trackDtailVo.lyricsDetail || '',
                    track: trackDtailVo.track || {},
                    trackArtists: albumVo.albumArtists,
                    errorMsg: alertInfo,
                    tracks,
                    hasAuditPassRecord,
                    newUnPassAudit,
                };
                this.allArtistInfo = albumVo.albumArtists.map((item) => ({
                    value: item.artistId,
                    name: item.artistName,
                    type: item.type,
                    appleId: item.appleId,
                    spotifyId: item.spotifyId,
                }));

                this.allArtistValueOptions = albumVo.albumArtists.map((item) => ({
                    isRole: 0,
                    name: item.typeName,
                    value: item.type,
                }));

                // 三方平台艺人关联统计（来自 album_info 接口）
                this.thirdPartyPlatformStats = thirdPartyPlatformStats || [];

                // 获取艺人关联进度
                this.fetchArtistProgress();
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.dataLoading = false;
            }
        },
        download(filePath, fileName) {
            downLoadByUri(filePath, fileName);
        },
        toReleaseArtistDrawer(isView) {
            this.$refs.albumReleaseDialogRef.open(!!isView);
        },
        /**
         * 艺人进度条点击处理
         * @param {Boolean} isView 是否为查看模式
         */
        handleArtistProgressClick(isView) {
            this.toReleaseArtistDrawer(isView);
        },
        /**
         * 获取艺人关联进度
         */
        async fetchArtistProgress() {
            if (!this.allArtistInfo || this.allArtistInfo.length === 0) {
                this.artistProgressData = [];
                return;
            }
            const ids = [...new Set(this.allArtistInfo.map(item => item.value).filter(Boolean))];
            if (ids.length === 0) {
                this.artistProgressData = [];
                return;
            }
            try {
                const res = await fetchListRelateArtist(ids);
                if (res.data && res.data.state) {
                    this.artistProgressData = res.data.result || [];
                }
            } catch (error) {
                console.error('获取艺人关联进度失败', error);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.album-detail-box {
    .album-hd {
        display: flex;

        .image {
            margin-right: 60px;
            position: relative;

            .el-image {
                border-radius: 6px;
                width: 140px;
                height: 140px;
                margin-bottom: 20px;
            }

            &::after {
                content: '';
                background: url('~@/assets/img/album/pic_cd.png') no-repeat center;
                background-size: cover;
                width: 30px;
                height: 108px;
                position: absolute;
                top: 16px;
                right: -30px;
            }

            .el-button {
                width: 140px;
            }
        }

        .describe {
            h2 {
                font-size: 24px;
                line-height: 24px;
                margin-bottom: 30px;
            }
        }

        .status {
            img {
                width: 80px;
            }
        }
    }

    .album-info {
        padding: 60px 0;
        border-top: 1px solid #f2f2f2;

        .title {
            font-size: 18px;
            font-weight: 600;
            color: #000000;
            line-height: 18px;
            margin-bottom: 50px;
        }

        .el-descriptions {
            width: 100%;

            tbody td {
                padding-bottom: 50px;
            }

            th {
                font-weight: 600;
                color: #303133;
                padding: 10px;
            }

            td {
                font-weight: 400;
                color: #303133;
                padding: 10px;
            }
        }
    }

    .audio-upload-paly {
        width: 400px;
    }

    .el-descriptions-item__content {
        width: 40%;
    }

    .el-textarea.is-disabled .el-textarea__inner {
        background-color: transparent;
        border: none;
        color: #606266;
    }
}
</style>
